var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.974 6.91-9.23-5.332a4.368 4.368 0 0 0-4.343 0L4.173 6.91A4.343 4.343 0 0 0 2 10.672v10.685a4.344 4.344 0 0 0 2.172 3.73l9.23 5.331a4.344 4.344 0 0 0 4.343 0l9.23-5.331a4.343 4.343 0 0 0 2.171-3.763V10.64a4.34 4.34 0 0 0-2.172-3.73zM4.172 10.672a2.172 2.172 0 0 1 1.086-1.884l9.23-5.326a2.158 2.158 0 0 1 2.17 0l9.23 5.326a2.172 2.172 0 0 1 1.086 1.851v1.085a3.2 3.2 0 0 1-3.192 3.187H7.364a5.305 5.305 0 0 0-3.192 1.06v-5.3zm22.802 10.652a2.17 2.17 0 0 1-1.085 1.884l-9.231 5.326a2.172 2.172 0 0 1-2.173 0l-9.23-5.326a2.17 2.17 0 0 1-1.085-1.851V20.27a3.198 3.198 0 0 1 3.192-3.186h16.418a5.304 5.304 0 0 0 3.192-1.059v5.3zM10.524 10.13h2.106v3.154h2.172v-3.155a2.172 2.172 0 0 0-2.172-2.172h-2.106a2.172 2.172 0 0 0-2.172 2.171v3.154h2.172v-3.155zm0 11.737h2.106v-3.154h2.172v3.154a2.172 2.172 0 0 1-2.172 2.172h-2.106a2.172 2.172 0 0 1-2.172-2.173v-3.154h2.172v3.154zM19.08 10.13h2.112v3.154h2.172v-3.155a2.172 2.172 0 0 0-2.172-2.172H19.08a2.172 2.172 0 0 0-2.171 2.171v3.154h2.17v-3.155zm0 11.737h2.112v-3.154h2.172v3.154a2.172 2.172 0 0 1-2.172 2.172H19.08a2.172 2.172 0 0 1-2.171-2.173v-3.154h2.17v3.154z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHez);
export default __webpack_public_path__ + "static/media/HEZ.fe7f1dc3a177b1ed9319d347d09d7227.svg";
export { ForwardRef as ReactComponent };